import { render, staticRenderFns } from "./selectRoleLabel.vue?vue&type=template&id=01e8e20a"
import script from "./selectRoleLabel.vue?vue&type=script&lang=js"
export * from "./selectRoleLabel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/kasingkhoo/Projects/PECOS/pecos_ivm_apiserver-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('01e8e20a')) {
      api.createRecord('01e8e20a', component.options)
    } else {
      api.reload('01e8e20a', component.options)
    }
    module.hot.accept("./selectRoleLabel.vue?vue&type=template&id=01e8e20a", function () {
      api.rerender('01e8e20a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/users/components/selectRoleLabel.vue"
export default component.exports